// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3kHmy","inputWrap":"styles_inputWrap__YJTJ4","input":"styles_input__JcYMq"};